import React from 'react';
import {Navigate, Outlet, useLocation, useMatches} from 'react-router';
import {Layout} from '../ui';
import {MenuItem} from '@gravity-ui/navigation';
import {useSession} from '../../../entities/auth/hooks/useSession';
import {resolveRouteRedirect} from '../../../app/router/roleGuard';
import {AppRole} from '../../../entities/auth/model';

const findActiveItemIndex = (items: MenuItem[], pathname: string): number => {
  let bestMatchIndex = -1;
  let maxMatchLength = -1;

  items.forEach((item, index) => {
    if (item.href && pathname.startsWith(item.href)) {
      if (item.href.length > maxMatchLength) {
        maxMatchLength = item.href.length;
        bestMatchIndex = index;
      }
    }
  });

  return bestMatchIndex;
};

interface LayoutWithBreadcrumbsProps {
  defaultMenuItems: MenuItem[];
}

export const LayoutWithBreadcrumbs = ({defaultMenuItems}: LayoutWithBreadcrumbsProps) => {
  const matches = useMatches();
  const location = useLocation();
  const currentPathname = location.pathname;
  const {role} = useSession();

  const currentRouteMatch = [...matches].reverse().find((match) => match.handle && (match.handle as any).menuItems);
  const handle = currentRouteMatch?.handle as any;
  const baseMenuItems = handle?.menuItems || defaultMenuItems;
  const allowedRoles: AppRole[] | undefined = handle?.allowedRoles;

  const redirect = resolveRouteRedirect(role, allowedRoles);
  if (redirect) {
    return <Navigate to={redirect} replace />;
  }

  const activeItemIndex = findActiveItemIndex(baseMenuItems, currentPathname);

  const processedMenuItems = baseMenuItems.map((item: MenuItem, index: number) => ({
    ...item,
    current: index === activeItemIndex,
  }));

  return (
    <Layout menuItems={processedMenuItems}>
      <Outlet />
    </Layout>
  );
};
